import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { CallState } from "redmond";
import { BookingErrorModal } from "./component";
import {
  getCombinedBookingSteps,
  getErrorTitles,
  getHasAttemptedReshop,
  getHasError,
  getIsBookingValid,
  getIsConnectionError,
  getIsHotelUnavailableError,
  getModalType,
  getPollPriceQuoteCallState,
  getSelectedPaymentMethodId,
  getSession,
  getUserSelectedTravelerId,
  hotelBookTypeSelector,
  Progress,
  getHotelCfarDetailsAtPriceQuoteSelector,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import {
  scheduleBook,
  acknowledgePriceDifference,
  resetBookErrors,
  markReshopAttempted,
  schedulePriceQuote,
  markConnectionRetryPending,
} from "../../actions/actions";
import { setHotelShop } from "../../../shop/actions/actions";
import {
  setSelectedCfarId,
  setHasSelectedRefundableRoom,
} from "../../../ancillary/actions/actions";
import {
  getAdultsCount,
  getChildren,
  getFromDate,
  getPetsCount,
  getRoomsCount,
  getUntilDate,
} from "../../../search/reducer";
import {
  getHotelShopCancellationSummary,
  getHotelShopChosenProduct,
  getHotelShopChosenRoomInfo,
  getHotelShopLodgingSelection,
  getHotelShopSelectedLodging,
} from "../../../shop/reducer/selectors";
import { getHotelQueryParams } from "../../../availability/reducer";
import { getAllAncillaries } from "../../../ancillary/reducer";

const mapStateToProps = (state: IStoreState) => ({
  hasError: getHasError(state),
  errorTitles: getErrorTitles(state),
  isUnavailableError: getIsHotelUnavailableError(state),
  paymentMethodId: getSelectedPaymentMethodId(state),
  currentSession: getSession(state),
  selectedTravelerId: getUserSelectedTravelerId(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  lodging: getHotelShopSelectedLodging(state),
  children: getChildren(state),
  adultsCount: getAdultsCount(state),
  isBookingValid: getIsBookingValid(state),
  priceQuoteSuccessful: getPollPriceQuoteCallState(state) === CallState.Success,
  hotelQueryParams: getHotelQueryParams(state),
  modalType: getModalType(state),
  roomsCount: getRoomsCount(state),
  petsCount: getPetsCount(state),
  ancillaries: getAllAncillaries(state),
  step: getCombinedBookingSteps(state).find(
    (s) => s.status === Progress.IN_PROGRESS
  )?.name,
  hotelBookType: hotelBookTypeSelector(state),
  hotelCfarDetailsAtPriceQuote: getHotelCfarDetailsAtPriceQuoteSelector(state),
  lodgingSelection: getHotelShopLodgingSelection(state),
  // The room/rate the user chose before it went unavailable — the embedded
  // widget has its own store and can't know it.
  chosenRoomInfo: getHotelShopChosenRoomInfo(state),
  chosenProduct: getHotelShopChosenProduct(state),
  cancellationSummary: getHotelShopCancellationSummary(state),
  hasAttemptedReshop: getHasAttemptedReshop(state),
  isConnectionError: getIsConnectionError(state),
});

const mapDispatchToProps = {
  scheduleBook,
  resetBookErrors,
  acknowledgePriceDifference,
  markReshopAttempted,
  schedulePriceQuote,
  setHotelShop,
  setSelectedCfarId,
  setHasSelectedRefundableRoom,
  markConnectionRetryPending,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type BookingErrorModalConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedBookingErrorModal = withRouter(
  connector(BookingErrorModal)
);
